import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useMemo } from 'react';
import LoadingEllipsis from '@/common/LoadingEllipsis';
import { usePriceDrop } from '~/hooks/vdp';
import ReductionTag from '~/icons/ReductionTag';
import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import PriceDrop from './PriceDrop';
import {
  OriginalPrice,
  Price,
  TradeIncentiveCopy,
  Wrapper
} from './Pricing.styles';

export type OwnProps = {
  discount: number;
  hasDiscount: boolean;
  isLoading: boolean;
  isTradeInApplied: boolean;
  previousPrice: number;
  price: number;
  tradeIncentive: number;
};

function PriceWithDiscount({
  discount,
  isTradeInApplied,
  price,
  tradeIncentive
}: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  return (
    <>
      <OriginalPrice>
        {price ? `$${formatAndDropDecimal(price)}` : ''}
      </OriginalPrice>
      <Price>{price ? `$${formatAndDropDecimal(price - discount)}` : ''}</Price>
      {tradeIncentive > 0 ? (
        <TradeIncentiveCopy
          onChange={inView => {
            if (!inView) return;
            trackEvent('Viewed TradeIn Discount In Header');
          }}
          triggerOnce
        >
          <ReductionTag className="green" />{' '}
          {isTradeInApplied
            ? `$${formatAndDropDecimal(tradeIncentive)} off with trade-in`
            : `Save $${formatAndDropDecimal(tradeIncentive)} with a trade-in`}
        </TradeIncentiveCopy>
      ) : null}
    </>
  );
}

const PriceWithoutDiscount = ({ price, tradeIncentive }: OwnProps) => (
  <>
    <Price>{price ? `$${formatAndDropDecimal(price)}` : ''}</Price>
    {tradeIncentive > 0 ? (
      <TradeIncentiveCopy>
        <ReductionTag className="green" /> Save $
        {formatAndDropDecimal(tradeIncentive)} with a trade-in
      </TradeIncentiveCopy>
    ) : null}
  </>
);

function Content(props: OwnProps) {
  const { showPriceDrop } = usePriceDrop();
  const { hasDiscount } = props;
  const PriceToShow = useMemo(() => {
    switch (true) {
      case showPriceDrop:
        return PriceDrop;
      case hasDiscount:
        return PriceWithDiscount;
      default:
        return PriceWithoutDiscount;
    }
  }, [hasDiscount, showPriceDrop]);

  return <PriceToShow {...props} />;
}

export default function Pricing(props: OwnProps) {
  const { isLoading } = props;

  return (
    <Wrapper>
      {isLoading ? <LoadingEllipsis /> : <Content {...props} />}
    </Wrapper>
  );
}
